export default __webpack_public_path__ + "static/media/GLOB_img_2.cd2cedae.jpg";